import { createContext, useContext } from 'react';

export const SuggestionsContext = createContext(null);

export const useSuggestionsContext = () => {
  const context = useContext(SuggestionsContext);

  return context;
};
